import { AxiosResponse } from 'axios';
import { ToastService } from './toast.service';
import { AXIOS_STATUS, AxiosService } from '@umanforge/common';

/**
 * Vérifie si la réponse Axios est valide (status 200).
 * Affiche une erreur si la réponse n'est pas attendue.
 *
 * @param response - La réponse Axios à vérifier
 * @returns Les données de la réponse ou null si inattendue
 */
class ResponseService {
  private toastService: ToastService;

  constructor( toastService: ToastService ) {
    this.toastService = toastService;
  }

  /**
   * Affiche une erreur Axios dans un toast.
   * Si l'erreur est une erreur HTTP (4xx/5xx), un message adapté est affiché.
   * Sinon, on affiche le message brut de l'erreur.
   *
   * @param error - Une erreur de type AxiosError
   */
  handleUnexpectedResponse = <T> ( response: AxiosResponse<T> ): T | null => {
    if ( response.status === AXIOS_STATUS.OK ) {
      return response.data;
    } else if ( response.status === AXIOS_STATUS.CREATED ) {
      return null;
    } else {
      this.toastService.showError( AxiosService.getAxiosMessage( response ) );
      return null;
    }
  };
}

export { ResponseService };


